var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap -mb-4"},_vm._l((_vm.data),function(value,prop){return _c('div',{key:prop,staticClass:"w-full md:w-36 md:mr-4 mb-4"},[_c('div',{staticClass:"mb-2 bg-gray-500 dark:bg-gray-700 w-full md:w-36 h-36",style:({
        opacity: value
      })}),_c('CanvasBlockLabel',{attrs:{"label":`opacity-${prop}`,"value":value}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }